import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../layout/components/CustomButton";
import { RootState } from "../../../../redux/store";
import { Box, styled } from "@mui/material";
import { MdOutlineMyLocation } from "react-icons/md";
import { setIsMapOpen } from "../../../../redux/slice/apartmentRental/apartmentRentalSlice";
import { FaListUl, FaArrowLeft } from "react-icons/fa";

const NextButton = styled(CustomButton)(({ theme }) => ({
    width: 210,
    borderRadius: 28,
    cursor: "pointer",
    border: "none",
    "&:hover": {
        backgroundColor: theme.palette.secondary.contrastText,
        color: theme.palette.button.text,
        border: "none",
    },
    "&:focus": {
        outline: "none",
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.button.text,
    },
    color: theme.palette.button.text,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
}));

interface BookLocationNavigateNextActionProps {
    isMapView?: boolean;
}

const FloatingViewMapButton: React.FC<BookLocationNavigateNextActionProps> = ({
    isMapView = false,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const nextEnabled = useSelector((state: RootState) => state.bookingCreation.nextEnabled);
    const { isMapOpen, locationApartmentList, selectedApartment } = useSelector(
        (state: RootState) => state.apartment
    );

    const handleNextClick = () => {
        if (isMapView) {
            const modal = document.querySelector(".location-modal");
            if (modal) {
                modal.remove();
            }
        }
        dispatch(setIsMapOpen(!isMapOpen));
    };

    const showGoBackLabel = isMapView && Boolean(selectedApartment);

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                pointerEvents: "auto",
            }}
        >
            <NextButton
                disabled={locationApartmentList?.length === 0}
                key={`${nextEnabled}`}
                variant={nextEnabled ? "outlined" : "contained"}
                onClick={handleNextClick}
                isButtonDark={true}
            >
                {!isMapView ? (
                    <>
                        <MdOutlineMyLocation />
                        <span className="ml-4"> {t("apartment.map_view")}</span>
                    </>
                ) : showGoBackLabel ? (
                    <>
                        <FaArrowLeft className="mr-3" />
                        {t("book_location.go_back", { defaultValue: "Go Back" })}
                    </>
                ) : (
                    <>
                        <span className="mr-4">
                            <FaListUl />
                        </span>
                        {t("apartment.show_list")}
                    </>
                )}
            </NextButton>
        </Box>
    );
};

export default FloatingViewMapButton;
